(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/data/channels.js'),
            require('../enums/colors.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js'),
            require('../modules/utils/metric.js'),
            require('../modules/utils/keywords.js'),
            undefined, // views are not used server-side
            require('lodash')
        );

    } else {
        RivalIQ.metrics.definitions.tiktok = exportFn(
            RivalIQ.data.channels,
            RivalIQ.enums.colors,
            RivalIQ.enums,
            RivalIQ.strings,
            RivalIQ.utils.metric,
            RivalIQ.utils.keywords,
            RivalIQ.views.metric,
            window._
        );
    }

    function exportFn(channels, colors, metricEnums, strings, utils, keywordsUtils, views, _) {
        function valueByDimension(dimension, a, b) {
            return function (val, metric) {
                if (utils.useDetailsDescription(metric)) {
                    return a;
                }
                return b;
            };
        }

        const channel = channels.get('tiktok');

        return {
            className: channel.get('channel'),
            format: channel.get('name'),
            name: channel.get('name'),
            color: colors.tiktokHighContrast,
            audience: {
                name: 'Followers',
                description: strings.tiktok_audience_description
            },
            presence_reach: {
                name: 'Followers',
                description: strings.tiktok_audience_description
            },
            count: {
                name: 'Videos',
                description: strings.tiktok_count_description
            },
            avg_count_per_day: {
                name: 'Videos / Day',
                description: strings.tiktok_avg_count_per_day_description
            },
            avg_count_per_week: {
                name: 'Videos / Week',
                description: strings.tiktok_avg_count_per_week_description
            },
            comments: {
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                description: strings.tiktok_insights_comments_description
            },
            comments_insights: {
                name: 'Comments',
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                description: strings.tiktok_insights_comments_description,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            engagement_total: {
                description: valueByDimension('post', strings.tiktok_post_engagement_total_description, strings.tiktok_engagement_total_description)
            },
            engagement_total_insights: {
                collection: metricEnums.collection.ENGAGEMENT,
                name: 'Engagement Total',
                description: strings.tiktok_engagement_total_description,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            avg_engagement_rate_per_post: {
                description: strings.tiktok_avg_engagement_rate_per_post_description
            },
            engagement_type: {
                // This defines the order these will appear in bar charts.
                dimensionValues: _.constant(['applause', 'conversation', 'amplification']),

                value: {
                    applause: {
                        className: 'x-tiktok',
                        format: utils.formatDimensionFn('Likes'),
                        engagement_total: {
                            name: 'Likes',
                            description: valueByDimension('post', strings.tiktok_post_applause_engagement_total_description, strings.tiktok_applause_engagement_total_description)
                        },
                        avg_engagement_total_per_day: {
                            name: 'Likes / Day',
                            description: strings.tiktok_applause_avg_engagement_total_per_day_description
                        }
                    },
                    amplification: {
                        className: 'x-tiktok-secondary',
                        format: utils.formatDimensionFn('Shares'),
                        engagement_total: {
                            name: 'Shares',
                            description: valueByDimension('post', strings.tiktok_post_amplification_engagement_total_description, strings.tiktok_amplification_engagement_total_description)
                        },
                        avg_engagement_total_per_day: {
                            name: 'Shares / Day',
                            description: strings.tiktok_amplification_avg_engagement_total_per_day_description
                        }
                    },
                    conversation: {
                        className: 'x-tiktok-tertiary',
                        format: utils.formatDimensionFn('Comments'),
                        engagement_total: {
                            name: 'Comments',
                            description: valueByDimension('post', strings.tiktok_post_conversation_engagement_total_description, strings.tiktok_conversation_engagement_total_description)
                        },
                        avg_engagement_total_per_day: {
                            name: 'Comments / Day',
                            description: strings.tiktok_conversation_avg_engagement_total_per_day_description
                        }
                    }
                }
            },
            engagement_total_per_post: {
                name: 'Engagement Total / Video',
                description: strings.tiktok_engagement_total_per_post_description
            },
            net_followers: {
                name: 'Followers Net Change',
                type: metricEnums.dataType.INTEGER,
                collection: metricEnums.collection.AUDIENCE,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            profile_views: {
                name: 'Profile Views',
                type: metricEnums.dataType.INTEGER,
                collection: metricEnums.collection.ENGAGEMENT,
                description: strings.tiktok_insights_profile_views_description,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            posts_per_day: {
                name: 'Posts / Day',
                description: strings.tiktok_insights_posts_posts_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            posts_per_week: {
                name: 'Posts / Week',
                description: strings.tiktok_insights_posts_posts_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            views: {
                name: 'Views',
                category: 'post_analysis', // this makes this metric show up in the post modal.
                description: valueByDimension('post', strings.tiktok_post_views_description, strings.tiktok_views_description),
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                metricCategory: metricEnums.category.ENGAGEMENT
            },
            views_per_follower: {
                name: 'Views / Follower',
                description: strings.tiktok_views_per_follower_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                summable: false
            },
            views_per_post: {
                name: 'Views / Video',
                description: strings.tiktok_views_per_post_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                summable: false,
                metricCategory: metricEnums.category.ENGAGEMENT
            },
            avg_views_per_day: {
                name: 'Views / Day',
                description: strings.tiktok_avg_views_per_day_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                summable: false,
                metricCategory: metricEnums.category.ENGAGEMENT
            },
            engagement_total_per_view: {
                name: 'Engagement Rate by View',
                description: function (val, metric) {
                    if (_.includes(metric.dimensions, 'post')) {
                        return strings.tiktok_engagement_total_per_view_post_description;
                    } else {
                        return strings.tiktok_engagement_total_per_view_description;
                    }
                },
                collection: metricEnums.collection.ENGAGEMENT,
                summable: false,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                cellView: function (data, metric) {
                    return (data[0] !== '__SUMMARY_ROW__' && metric.isNotRelative(data) ? views.Bar : undefined);
                },
                metricCategory: metricEnums.category.ENGAGEMENT
            },
            engagement_rate: {
                description: strings.tiktok_post_engagement_rate_description
            },
            engagement_rate_by_impression: {
                name: 'Engagement Rate by Impression',
                description: function (val, metric) {
                    if (_.includes(metric.dimensions, 'post')) {
                        return strings.tiktok_engagement_rate_by_impression_post_description;
                    } else {
                        return strings.tiktok_engagement_rate_by_impression_description;
                    }
                },
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            engagement_rate_by_presence_reach: {
                name: 'Engagement Rate by Reach',
                description: strings.tiktok_insights_engagement_rate_by_presence_reach,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            engagement_rate_by_view: {
                name: 'Engagement Rate by View',
                description: function (val, metric) {
                    if (_.includes(metric.dimensions, 'post')) {
                        return strings.tiktok_engagement_total_per_view_post_description;
                    } else {
                        return strings.tiktok_engagement_total_per_view_description;
                    }
                }
            },
            impressions: {
                collection: metricEnums.collection.IMPRESSIONS,
                description: strings.tiktok_insights_impressions_description
            },
            likes: {
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                description: strings.tiktok_insights_likes_description
            },
            likes_insights: {
                name: 'Likes',
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                description: strings.tiktok_insights_likes_description,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            media_type: {
                name: 'Post Type',
                collection: metricEnums.collection.GENERAL,
                type: metricEnums.dataType.STRING,
                description: strings.tiktok_insights_post_media_type_description
            },
            overview: {
                description: strings.tiktok_overview_description
            },
            shares: {
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                description: strings.tiktok_insights_shares_description
            },
            shares_insights: {
                name: 'Shares',
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                description: strings.tiktok_insights_shares_description,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            social_engagement_rate_by_impression: {
                name: 'Social Engagement Rate by Impression',
                description: valueByDimension('post', strings.tiktok_insights_post_social_engagement_rate_by_impression_description, strings.tiktok_insights_posts_social_engagement_rate_by_impression_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            social_engagement_total: {
                name: 'Social Engagement Total',
                description: valueByDimension('post', strings.tiktok_insights_post_social_engagement_total_description, strings.tiktok_insights_posts_social_engagement_total_description),
                type: metricEnums.dataType.INTEGER,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            },
            video_views_insights: {
                name: 'Video Views',
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: strings.tiktok_insights_video_views_description,
                source: metricEnums.sources.TIKTOK_INSIGHTS
            }
        };
    }
})();
